import { render, staticRenderFns } from "./CotacoesMarketplace.vue?vue&type=template&id=debd9bb0"
import script from "./CotacoesMarketplace.vue?vue&type=script&lang=js"
export * from "./CotacoesMarketplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports